import React from 'react';
import {getPaymentNotice} from './paymentStatus';


const toneClasses = {
  danger: 'border-red-300 bg-red-50 text-red-800',
  warning: 'border-amber-300 bg-amber-50 text-amber-900',
  success: 'border-green-300 bg-green-50 text-green-800',
  neutral: 'border-slate-300 bg-slate-50 text-slate-800',
};


export const PaymentLoginDetails = ({status}) => {
  if (!status?.user_username && !status?.payment_dashboard_url) return null;

  return (
    <div className="mt-3 border-t border-current/20 pt-3 text-sm">
      <p className="mb-1 font-semibold">Payment-Dashboard Zugang:</p>
      {status.user_username && (
        <>
          <code className="inline-block rounded border bg-white px-2 py-1 text-xs">
            Username: {status.user_username}
          </code>
          <p className="mt-1 text-xs">
            <strong>Passwort: Das Passwort ist identisch mit dem Username.</strong>
          </p>
        </>
      )}
      {status.payment_dashboard_url && (
        <a
          href={status.payment_dashboard_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-block font-medium text-blue-700 underline hover:text-blue-900"
        >
          Zum Payment-Dashboard →
        </a>
      )}
    </div>
  );
};


const PaymentStatusNotice = ({status, expanded = false, onToggle = () => {}}) => {
  const notice = getPaymentNotice(status);
  if (!notice) return null;

  const colors = toneClasses[notice.tone] || toneClasses.neutral;

  if (notice.compact) {
    return (
      <div className="mb-6">
        <button
          type="button"
          aria-expanded={expanded}
          onClick={onToggle}
          className={`rounded-lg border px-3 py-2 text-sm font-medium transition-colors ${colors}`}
        >
          {notice.title} <span aria-hidden="true">{expanded ? '▲' : '▼'}</span>
        </button>
        {expanded && (
          <div className={`mt-2 rounded-lg border p-4 ${colors}`}>
            <p className="font-semibold">{notice.title}</p>
            {notice.message && (
              <p className="mt-2 text-sm leading-6">{notice.message}</p>
            )}
            <PaymentLoginDetails status={status} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`mb-6 rounded-lg border-2 p-4 ${colors}`} role="status">
      <h3 className="mb-2 text-lg font-bold">{notice.title}</h3>
      {notice.message && <p className="text-sm leading-6">{notice.message}</p>}
      <PaymentLoginDetails status={status} />
    </div>
  );
};


export default PaymentStatusNotice;
